import React from "react";
import { string, bool, func } from "prop-types";
import Avatar from "@shared/v2/Avatar";
import Envelope from "@shared/v2/Icomoon/Icons/Envelope";
import Phone from "@shared/v2/Icomoon/Icons/Phone";
import IconButton from "@shared/v2/IconButton";
import XmarkSolidV6 from "@shared/v2/Icomoon/Icons/XmarkSolidV6";
import PencilSolidV6 from "@shared/v2/Icomoon/Icons/PencilSolidV6";
import { truncateWord } from "../model/ConactOptions";

const ContactInfoCard = ({
  name,
  avatarImg,
  role,
  email,
  phone,
  canEdit,
  canDelete,
  handleDelete,
  handleEditClick,
  isEditFormOpen,
}) => (
  <div className="tw-border-solid tw-bg-[#FFFFFF] tw-border-neutral-gray-10 tw-w-[552px] tw-mb-[8px] !tw-p-[11px] tw-border tw-rounded-8px">
    <div className=" tw-grid tw-grid-cols-6 tw-gap-[16px] tw-h-[42px]">
      <div className="tw-col-span-2 tw-flex ">
        <Avatar className="tw-w-[40px] tw-h-[40px]" src={avatarImg} alt={name} />
        <span
          className={`${!role && "tw-flex tw-items-center"} tw-pl-[13px] tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-75`}
        >
          {truncateWord(name, 13)}

          {role && (
            <div className="tw-text-12px tw-leading-[16px] tw-text-gray-50">{truncateWord(role, 13)}</div>
          )}
        </span>
      </div>
      <div className={`tw-col-span-3  tw-flex ${(!email || !phone) && "tw-items-center"}`}>
        <div className="tw-text-14px tw-leading-[20px] tw-font-normal tw-text-gray-75">
          {email && (
            <div>
              <Envelope className="tw-mb-[-3px] tw-pr-[8px] tw-w-[24px] tw-h-[16px]" />
              {truncateWord(email, 28)}
            </div>
          )}
          {phone && (
            <div className={`${email && "tw-pt-[4px]"}`}>
              <Phone className="tw-mb-[-3px] tw-pr-[8px] tw-w-[24px] tw-h-[16px]" />
              {truncateWord(phone, 28)}
            </div>
          )}
        </div>
      </div>
      <div className="tw-col-span-1  tw-flex tw-items-center tw-justify-end">
        {canEdit && (
          <IconButton schema="tertiary" size="small" onClick={handleEditClick} disabled={isEditFormOpen}>
            <PencilSolidV6 size="m" />
          </IconButton>
        )}
        {canDelete && (
          <IconButton className="tw-ml-[8px]" schema="tertiary" size="small" onClick={handleDelete}>
            <XmarkSolidV6 size="m" />
          </IconButton>
        )}
      </div>
    </div>
  </div>
);

ContactInfoCard.propTypes = {
  name: string,
  avatarImg: string,
  role: string,
  email: string,
  phone: string,
  canEdit: bool,
  canDelete: bool,
  handleDelete: func,
  handleEditClick: func,
  isEditFormOpen: bool,
};

ContactInfoCard.defaultProps = {
  name: null,
  avatarImg: null,
  role: null,
  email: null,
  phone: null,
  canEdit: false,
  canDelete: false,
  handleDelete: null,
  handleEditClick: null,
  isEditFormOpen: false,
};

export default ContactInfoCard;
